import PropTypes from 'prop-types';
import clsx from 'clsx';

const ShipDetails = ({ ship }) => {
  const factNameStyle = clsx('font-bold inline-block');
  return (
    <div className="p-10">
      <h1 className="text-lg font-bold">{ship.shipName}</h1>
      <p dangerouslySetInnerHTML={{ __html: ship.shipDescription }} />
      <h1 className="text-lg font-bold mt-5 mb-2 hidden">Ship facts</h1>
      <div className="grid sm:grid-cols-3 md:grid-cols-4 gap-y-5 hidden">
        <div>
          <div className={factNameStyle}>Ship capacity:</div>
          {' '}
          {ship.shipCapacity || 0}
        </div>
        <div>
          <div className={factNameStyle}>Casino:</div>
          {' '}
          {ship.shipHasCasino ? 'Yes' : 'No'}
        </div>
        <div>
          <div className={factNameStyle}>Children&apos;s program:</div>
          {' '}
          {ship.shipHasChildrensProgram ? 'Yes' : 'No'}
        </div>
        <div>
          <div className={factNameStyle}>Disco:</div>
          {' '}
          {ship.shipHasDisco ? 'Yes' : 'No'}
        </div>
        <div>
          <div className={factNameStyle}>Fitness center:</div>
          {' '}
          {ship.shipHasFitnessCenter ? 'Yes' : 'No'}
        </div>
        <div>
          <div className={factNameStyle}>Internet cafe:</div>
          {' '}
          {ship.shipHasInternetCafe ? 'Yes' : 'No'}
        </div>
        <div>
          <div className={factNameStyle}>Library:</div>
          {' '}
          {ship.shipHasLibrary ? 'Yes' : 'No'}
        </div>
        <div>
          <div className={factNameStyle}>Meeting rooms:</div>
          {' '}
          {ship.shipHasMeetingRooms ? 'Yes' : 'No'}
        </div>
        <div>
          <div className={factNameStyle}>Shops:</div>
          {' '}
          {ship.shipHasShops ? 'Yes' : 'No'}
        </div>
        <div>
          <div className={factNameStyle}>Spa:</div>
          {' '}
          {ship.shipHasSpa ? 'Yes' : 'No'}
        </div>
        <div>
          <div className={factNameStyle}>Number of bars:</div>
          {' '}
          {ship.shipNumBars || 0}
        </div>
        <div>
          <div className={factNameStyle}>Number of cabins:</div>
          {' '}
          {ship.shipNumCabins || 0}
        </div>
        <div>
          <div className={factNameStyle}>Number of elevators:</div>
          {' '}
          {ship.shipNumElevators || 0}
        </div>
        <div>
          <div className={factNameStyle}>Number of accessible cabins:</div>
          {' '}
          {ship.shipNumHandicapCabins || 0}
        </div>
        <div>
          <div className={factNameStyle}>Number of pools:</div>
          {' '}
          {ship.shipNumPools || 0}
        </div>
        <div>
          <div className={factNameStyle}>Number of restaurants:</div>
          {' '}
          {ship.shipNumRestaurants || 0}
        </div>
        <div>
          <div className={factNameStyle}>Theater:</div>
          {' '}
          {ship.shipNumTheaters === 'Y' ? 'Yes' : 'No'}
        </div>
        <div>
          <div className={factNameStyle}>Ship tonnage:</div>
          {' '}
          {ship.shipTonnage || 0}
        </div>
        <div>
          <div className={factNameStyle}>Year built:</div>
          {' '}
          {ship.shipYearBuilt || 0}
        </div>
        <div>
          <div className={factNameStyle}>Year refurbished:</div>
          {' '}
          {ship.shipYearRefurbished || '-'}
        </div>
      </div>
    </div>
  );
};

ShipDetails.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  ship: PropTypes.object,
};

ShipDetails.defaultProps = {
  ship: undefined,
};

export default ShipDetails;
